export default __webpack_public_path__ + "static/media/417.a1c14505.png";